import React from "react";
import GenerativeCards from "./GenerativeCards";
import "./Chatbot.css";

function formatContent(text) {
  if (!text) return "";

  // 0. Escape HTML first so model output can never inject markup (we add our own tags below)
  text = String(text).replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;");

  // 1. Strip raw markdown links: [Title](url) -> <strong>Title</strong>
  let html = text.replace(
    /\[(.*?)\]\((https?:\/\/[^\s)]+)\)/g,
    '<strong>$1</strong>'
  );

  // Strip internal markdown links: [Title](/tours/123) -> <strong>Title</strong>
  html = html.replace(
    /\[(.*?)\]\(\/[^\s)]+\)/g,
    '<strong>$1</strong>'
  );

  // 2. Strip raw markdown images
  html = html.replace(/!\[.*?\]\([^)]+\)/g, '');

  // 3. Headings: ### Title -> <strong class="tgh-chat-heading">Title</strong>
  html = html.replace(/^### (.*$)/gim, '<strong class="tgh-chat-heading">$1</strong>');
  html = html.replace(/^## (.*$)/gim, '<strong class="tgh-chat-heading">$1</strong>');

  // 4. Bold: **text** -> <strong>text</strong>
  html = html.replace(/\*\*(.*?)\*\*/g, '<strong>$1</strong>');

  // 5. Clean Bullet points
  html = html.replace(/^\s*[-*]\s+(.*$)/gim, '<span class="tgh-chat-bullet">•</span> $1');

  // 6. Line breaks
  html = html.replace(/\n/g, "<br/>");

  return html;
}

/**
 * Renders a single chat message bubble with dynamic Generative UI cards.
 */
export default function ChatMessage({ message, onOpenPreview, onAskAbout }) {
  const isUser = message.role === "user";
  const isError = message.isError;

  let bubbleClass = "tgh-chat-msg";
  if (isUser) bubbleClass += " tgh-chat-msg--user";
  else bubbleClass += " tgh-chat-msg--bot";
  if (isError) bubbleClass += " tgh-chat-msg--error";

  return (
    <div className={bubbleClass}>
      {!isUser && (
        <div className="tgh-chat-avatar">
          <span>A</span>
        </div>
      )}
      <div className="tgh-chat-bubble">
        <div
          className="tgh-chat-text"
          dangerouslySetInnerHTML={{ __html: formatContent(message.content) }}
        />

        {/* Dynamic Generative UI Cards Carousel */}
        {message.cards && (
          <GenerativeCards
            cards={message.cards}
            onOpenPreview={onOpenPreview}
            onAskAbout={onAskAbout}
          />
        )}

        {/* Split screen fallback card if no generative cards present */}
        {!message.cards && message.preview && onOpenPreview && (
          <div className="tgh-chat-preview-card">
            <div>
              <span className="tgh-chat-preview-badge">Live Package</span>
              <span className="tgh-chat-preview-title">{message.preview.title}</span>
            </div>
            <button
              className="tgh-chat-preview-btn"
              onClick={() => onOpenPreview(message.preview)}
              title="Open Live Webpage Preview"
            >
              View Tour
            </button>
          </div>
        )}

        <span className="tgh-chat-time">
          {new Date(message.timestamp).toLocaleTimeString("en-IN", { hour: "2-digit", minute: "2-digit" })}
        </span>
      </div>
    </div>
  );
}